<template>
	<v-flex xs12 pb-5>
		<v-card class="flex pa-0">
			<v-toolbar flat color="grey lighten-5">
				<v-toolbar-title class="grey--text text--darken-4">Il mio Profilo</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>
			<v-divider></v-divider>
			<v-container fluid>
				<v-layout row align-center justify-center>
					<v-flex xs3 lg1 pr-3 class="text-xs-center">
						<image-input v-model="avatar" @input="uploadImage">
							<div slot="activator">
								<v-avatar size="64px" v-ripple v-if="!profile.avatar" class="grey lighten-3 mb-3">
									<v-icon x-large>account_circle</v-icon>
								</v-avatar>
								<v-avatar v-else
									:size="68" 
									v-ripple
									class="custom-avatar mb-3"
									:style="{'background-image': 'url(' + profile.avatar + ')'}">
								</v-avatar>
							</div>
						</image-input>
					</v-flex>
					<v-flex xs lg11>
						<v-form v-model="valid" enctype="multipart/form-data">
							<v-text-field
									v-validate="'required|max:50'"
									data-vv-name="Nome e Cognome"
									:error-messages="errors.collect('Nome e Cognome')"
									v-model="name"
									required
									label="Nome e Cognome"
									type="text"
									@keyup.enter="submit"
								></v-text-field>
								<v-text-field
									v-validate="'required|email'"
									data-vv-name="Email"
									:error-messages="errors.collect('Email')"
									v-model="email"
									required
									label="Email"
									type="email"
									@keyup.enter="submit"
							></v-text-field>
						</v-form>
					</v-flex>
				</v-layout>
				<v-layout row>
					<v-flex xs12>
						<v-subheader class="pl-0">Modifica Password</v-subheader>
						<v-form v-model="validPassword" enctype="multipart/form-data">
							<v-text-field
								v-validate="'required|min:8'"
								data-vv-name="Password"
								:error-messages="errors.collect('Password')"
								v-model="password"
								label="Nuova Password"
								ref="password"
								required
								@keyup.enter="changePassowrd"
								:append-icon="e1 ? 'visibility' : 'visibility_off'"
								@click:append="() => {e1 = !e1}"
								:type="!e1 ? 'password' : 'text'"
							></v-text-field>
							<v-text-field
								v-validate="'required|confirmed:password'"
								data-vv-name="Conferma Password"
								:error-messages="errors.collect('Conferma Password')"
								v-model="confirmpassword"
								label="Conferma Password"
								required
								@keyup.enter="changePassowrd"
								:append-icon="e2 ? 'visibility' : 'visibility_off'"
								@click:append="() => {e2 = !e2}"
								:type="!e2 ? 'password' : 'text'"
							></v-text-field>
						</v-form>
					</v-flex>
				</v-layout>
				<v-layout align-end justify-end row>
					<v-btn @click="changePassowrd" :disabled="!validPassword" color="blue" class="white--text">
							MODIFICA PASSWORD
					</v-btn>
					<v-btn @click="$store.dispatch('AUTH_LOGOUT')" color="error">
						ESCI
					</v-btn>
				</v-layout>
			</v-container>
		</v-card>
		<v-btn
			fixed
			fab
			bottom
			right
			color="primary"
			:loading="saving"
			:disabled="!valid"
			@click="submit">
			<v-icon>check</v-icon>
		</v-btn>
	</v-flex>
</template>

<script>
import Vue from 'vue'
import ImageInput from '@/components/ImageInput.vue'

export default {
	name: 'profile',
	components: {
		ImageInput
	},
	props: {},
	data() {
		return {
			valid: false,
			validPassword: false,
			avatar: null,
			saving: false,
			name: '',
			email: '',
			password: '',
			confirmpassword: '',
			e1: false,
			e2: false
		}
	},

	computed: {
		profile() {
			return this.$store.getters.getProfile
		}
	},

	mounted() {
		let profile_temp = this.profile
		this.name = profile_temp.name
		this.email = profile_temp.email
	},

	created() {
		this.$store.commit('endProgress')
	},

	methods: {
		submit() {
			this.saving = true
			this.axios
				.put('users/' + this.profile.id, {
					name: this.name,
					email: this.email
				})
				.then(this.savedProfile)
		},

		changePassowrd() {
			this.$validator
				.validateAll()
				.then(result => {
					if (!result) {
						return false
					}

					this.saving = true
					this.axios
						.put('users/' + this.profile.id, {
							password: this.password,
							confirmpassword: this.confirmpassword
						})
						.then(this.savedProfile)
				})
				.catch(() => {})
		},

		uploadImage() {
			this.saving = true
			this.axios
				.put('users/' + this.profile.id, {
					avatar: this.avatar
				})
				.then(this.savedProfile)
		},

		savedProfile() {
			this.saving = false
			this.$store.commit('setSnackbar', {
				timeout: 6000,
				text: 'Profilo aggiornato',
				value: true,
				color: 'success'
			})
			this.$store.dispatch('USER_REQUEST')
		}
	}
}
</script>
